import React, { useEffect, useState } from "react";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Button, Modal, Table } from "antd";
import { Link } from "react-router-dom";
import {
  ErrorToast,
  SuccessToast,
  UpdatedToast,
} from "../../../views/ToastComponent";

const CateringBusiness = ({ ProfileId, profileId }) => {
  const [allBusinessPd, setAllBusinessPd] = React.useState([]);
  const [areaType, setAreaType] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [EditDataId, setEditDataId] = React.useState(0);

  const [garageAutoData, setGarageAutoData] = React.useState({
    name: "",
    numOfReceipt: 0,
    businessPdProfileId: profileId,
    latitude: "",
    longitude: "",
    profitMarginId: 0,
    receiptLast: 0,
    numOfPlate: 0,
    perPlateChrge: 0,
    grossReceipt: 0,
  });

  // singleuser

  const [cateringEditData, setCateringEditData] = useState({
    // id: 0,
    businessPdProfileId: profileId,
    name: "",
    profitMarginId: 0,
    numberOfPlate: 0,
    perPlateCharge: 0,
    totalReceiptAmount: 0,
    numberOfMonth: 0,
    latitude: "string",
    longitude: "string",
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setCateringEditData({
          ...cateringEditData,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  //update Method

  const handleUpdate = async (id) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/Catering/${id}`,
        cateringEditData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setIsEditModalOpen(false);
      fetchIncomeData();
    } catch (error) {
      return error;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Number of Plate",
      dataIndex: "numberOfPlate",
      // sorter: (a, b) => a.numberOfPlate.length - b.numberOfPlate.length,
    },
    {
      title: "Plate per Charge",
      dataIndex: "perPlateCharge",
      // sorter: (a, b) => a.perPlateCharge.length - b.perPlateCharge.length,
    },
    {
      title: "Reciepts Months",
      dataIndex: "numberOfMonth",
      // sorter: (a, b) => a.numberOfMonth.length - b.numberOfMonth.length,
    },
    {
      title: "Total Receipt Amount",
      dataIndex: "totalReceiptAmount",
      // sorter: (a, b) => a.totalReceiptAmount.length - b.totalReceiptAmount.length,
    },
    {
      title: "Created At",
      dataIndex: "created",
      render: (text) => {
        return (
          new Date(text).toLocaleDateString() +
          "   " +
          new Date(text).toLocaleTimeString()
        );
      },
      // sorter: (a, b) => a.created.length - b.created.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <Link to={`catering/${record.id}`}>
          <Button>View Details</Button>
        </Link>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const fetchIncomeData = async () => {
    const { data } = await axios.get(
      Api_Url +
        "api/v1/Catering/getallcateringsbybusinesspdprofileid/" +
        profileId,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken,
        },
      }
    );
    setAllBusinessPd(data);
  };

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(
        Api_Url + "api/v1/ProfitMargin/getbyprofileid/" + ProfileId,
        {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        }
      );
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setGarageAutoData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      return "Geolocation is not supported by this browser.";
    }
  };

  // Submitting the Data
  const handleSubmit = async (operationType) => {
    let response;
    try {
      const fromData = {
        businessPdProfileId: garageAutoData.businessPdProfileId,
        name: garageAutoData.name,
        profitMarginId: garageAutoData.profitMarginId,
        numberOfPlate: Number(garageAutoData.numOfPlate),
        perPlateCharge: Number(garageAutoData.perPlateChrge),
        totalReceiptAmount: Number(garageAutoData.receiptLast),
        numberOfMonth: Number(garageAutoData.numOfReceipt),
        latitude: garageAutoData.latitude,
        longitude: garageAutoData.longitude,
      };

      if (operationType == "Submit") {
        response = await axios.post(Api_Url + "api/v1/Catering", fromData, {
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user"))?.accessToken,
          },
        });
        fetchIncomeData();
        setGarageAutoData((prev) => ({
          ...prev,
          name: "",
          numOfReceipt: 0,
          businessPdProfileId: profileId,
          profitMarginId: 0,
          receiptLast: 0,
          numOfPlate: 0,
          perPlateChrge: 0,
          grossReceipt: 0,
        }));
        if (response.data.succeeded) {
          SuccessToast("Created Successfully");
          setIsModalOpen(false);
          fetchIncomeData();
        }
      } else {
        fromData.id = EditDataId;
        response = await axios.post(
          Api_Url + "api/v1/Catering/" + EditDataId,
          fromData,
          {
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user"))?.accessToken,
            },
          }
        );
        setGarageAutoData((prev) => ({
          ...prev,
          name: "",
          numOfReceipt: 0,
          businessPdProfileId: profileId,
          profitMarginId: 0,
          receiptLast: 0,
          numOfPlate: 0,
          perPlateChrge: 0,
          grossReceipt: 0,
        }));
        if (response.data.succeeded) {
          UpdatedToast("Updated Successfully");
          setIsModalOpen(false);
          fetchIncomeData();
        }
      }
    } catch (error) {
      ErrorToast("something went wrong");
      console.log(error);
    }
  };

  async function handleCancel() {
    setGarageAutoData({
      ...garageAutoData,
      name: "",
      numOfReceipt: 0,
      businessPdProfileId: profileId,
      profitMarginId: 0,
      receiptLast: 0,
      numOfPlate: 0,
      perPlateChrge: 0,
      grossReceipt: 0,
    });
    setEditDataId(0);
    setIsModalOpen(false);
  }

  const handleClick = async (id) => {
    setEditDataId(id);
    setIsModalOpen(true);
  };

  async function LoadSingleCableOperator(hereId) {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Catering/${hereId}`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      setGarageAutoData({
        ...garageAutoData,
        name: response.data.data.name,
        profitMarginId: response.data.data.profitMarginId,
        numOfReceipt: response.data.data.numberOfMonth,
        numOfPlate: response.data.data.numberOfPlate,
        receiptLast: response.data.data.totalReceiptAmount,
        perPlateChrge: response.data.data.perPlateCharge,
        // grossReceipt: response.data.data.,
      });
    } catch (e) {
      console.log("Load Single Auto Driver", e.message);
    }
  }

  const calculateMonthlyReciept =
    garageAutoData.receiptLast / garageAutoData.numOfReceipt || 0;

  useEffect(() => {
    if (EditDataId !== 0) {
      LoadSingleCableOperator(EditDataId);
    }
  }, [EditDataId !== 0]);

  React.useEffect(() => {
    fetchIncomeData();
    fetchAreaType();
    fetchCurentLocation();
  }, []);

  React.useEffect(() => {
    const result =
      garageAutoData.numOfPlate * garageAutoData.perPlateChrge || 0;
    setGarageAutoData((prev) => ({ ...prev, grossReceipt: result.toFixed(2) }));
  }, [garageAutoData.numOfPlate, garageAutoData.perPlateChrge]);

  // edit

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between">
          <h3 className="mb-0">Catering Business</h3>
          {allBusinessPd.length == 0 && (
            <button
              className="btn btn-primary submit-btn"
              onClick={() => setIsModalOpen(true)}
            >
              Add Catering Business
            </button>
          )}
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      {/* Garage Auto Form */}
      <Modal
        title={<h4>{EditDataId == 0 ? "Add" : "Edit"} Catering Business</h4>}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        // closable={false}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}
            >
              {EditDataId == 0 ? "Submit" : "Update"}
            </button>
            ,
          </div>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name of Catering</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Catering Name"
                    value={garageAutoData.name}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        name: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Number of Receipts Months
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of month"
                    value={garageAutoData.numOfReceipt}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (value <= 12) {
                        setGarageAutoData({
                          ...garageAutoData,
                          numOfReceipt: value,
                        });
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={garageAutoData.profitMarginId}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        profitMarginId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Area Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    {`Receipts (Last ${garageAutoData.numOfReceipt} Month)`}
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Last Month Receipts"
                    value={garageAutoData.receiptLast}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        receiptLast: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3 mb-4">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Monthly Receipts: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {calculateMonthlyReciept.toFixed(2) || "0.00"}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Number of Plate
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of Plate"
                    value={garageAutoData.numOfPlate}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        numOfPlate: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Per Plate Charge
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Per Plate Charge"
                    value={garageAutoData.perPlateChrge}
                    onChange={(event) =>
                      setGarageAutoData({
                        ...garageAutoData,
                        perPlateChrge: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3 mb-4">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Receipts: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {garageAutoData.grossReceipt || "0.00"}
                </span>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* catering Edit Form */}

      <Modal
        title={<h4>Edit Catering Business</h4>}
        open={isEditModalOpen}
        onOk={() => setIsEditModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleUpdate(cateringEditData.id)}
            >
              Update
            </button>
            ,
          </div>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: "red" }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Name of Catering</label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Catering Name"
                    value={cateringEditData.name}
                    onChange={(event) =>
                      setCateringEditData({
                        ...cateringEditData,
                        name: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Number of Receipts Months
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of month"
                    value={cateringEditData.numberOfMonth}
                    onChange={(event) =>
                      setCateringEditData({
                        ...cateringEditData,
                        numberOfMonth: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select
                    id="vehicleType"
                    className="custom-select-style"
                    value={cateringEditData.profitMarginId}
                    onChange={(event) =>
                      setCateringEditData({
                        ...cateringEditData,
                        profitMarginId: event.target.value,
                      })
                    }
                  >
                    <option value={0} selected>
                      Select Area Type
                    </option>
                    {areaType.length > 0 &&
                      areaType.map((area) => (
                        <option value={area.id}>{area.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    {`Receipts (Last ${cateringEditData.numberOfMonth} Month)`}
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Last Month Receipts"
                    value={cateringEditData.totalReceiptAmount}
                    onChange={(event) =>
                      setCateringEditData({
                        ...cateringEditData,
                        receiptLast: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3 mb-4">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Monthly Reciepts: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {calculateMonthlyReciept.toFixed(2) || "0.00"}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Number of Plate
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Number of Plate"
                    value={cateringEditData.numberOfPlate}
                    onChange={(event) =>
                      setCateringEditData({
                        ...cateringEditData,
                        numberOfPlate: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Per Plate Charge
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Per Plate Charge"
                    value={cateringEditData.perPlateCharge}
                    onChange={(event) =>
                      setCateringEditData({
                        ...cateringEditData,
                        perPlateCharge: event.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3 mb-4">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Gross Receipts: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {cateringEditData.grossReceipt || "0.00"}
                </span>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default CateringBusiness;
